import { useLayoutEffect } from "react";
import { registerConversationView } from "./conversationDiagnostics.mjs";

// Observe the existing commit and ref; no diagnostic React state or DOM changes.
export default function useConversationDiagnosticView(storeId, phone, ref) {
  useLayoutEffect(() => registerConversationView(storeId, phone, ref.current));
}